export default "__VITE_PUBLIC_ASSET__1ce1e75b__"